import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/horaires-de-travail")({
  staticData: {
    permission: PERMISSIONS.RH.PLANNING.VIEW,
  },
  component: () => <Outlet />,
});
